import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=93a58e92"
import script from "../services/PageNotFound.js?vue&type=script&lang=js&external"
export * from "../services/PageNotFound.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports